import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register the PWA service worker once, globally, as early as possible so:
//  (a) Chromium captures its `beforeinstallprompt` event and we can surface
//      a custom install banner to the user (pinned in App.js).
//  (b) Push subscriptions in `usePushNotifications` re-use the same registration.
// Safe to call on every load — `register()` is idempotent.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch(() => { /* non-fatal — PWA features just won't be available */ });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
